export default __webpack_public_path__ + "static/media/minus-thick.754aa712.svg";